/**
 * Entry point for the configuration of the Redux store
 * Configuration differs based on production vs dev servers
 */

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./configureStore.prod')
} else {
  module.exports = require('./configureStore.dev')
}



/** WEBPACK FOOTER **
 ** ./src/redux/store/configureStore.js
 **/